<template>
	<div id="page">
		<div v-if="showNotification" class="notification">
			Slow connection? Try <a href="https://lite.bookplate.co">Bookplate Lite</a>.
		</div>
		<nav role="navigation">
			<router-link to='/' class="logo-container">
				<img class="logo" src="/logo.png" alt="Bookplate">
				<span class="logo-text">Bookplate</span>
			</router-link>
			<router-link to='/'>Home</router-link>
			<router-link to='/library'>Library</router-link>
			<span v-if="$store.getters.userId == '0'" >
				<button v-on:click="showLogin" class="look-like-link">Sign In</button>
				<form id="login-widget" @submit.prevent="onSubmit">
					<div class="login-container">
						<button  class="cancel icon" type="cancel" v-on:click.prevent="hideLogin">Cancel</button>
					</div>
					<div class="login-container">
						<label for="email">Email</label>
						<input  placeholder="you@email.com" type="email" name="email" v-model="email" required>
					</div>
					<div class="login-container">
						<label :style="{float: 'left'}" for="password">Password</label>
						<router-link id="forgot-password" to='/forgot-password'>?</router-link>
						<label class="password-toggle-container">Show/Hide Password
							<input v-on:click="togglePassword" type="checkbox">
							<span class="checkmark"></span>
						</label>
						<input type="password" name="password" v-model="password" id="login-password" required>
					</div>
					<div class="login-container">
						<button id="login-submit-btn" type="submit">Log in</button>
					</div>
				</form>
			</span>
			<router-link v-else :to="{path:'/profile/' + $store.getters.userId}">Profile</router-link>
			<span class="mobile-navigation">
				<button v-on:click="toggleMenu" aria-controls="menu" aria-haspopup="true" class="look-like-link">Menu</button>
				<ul id="mobile-menu">
					<li>
						<router-link to='/'>Home</router-link>
					</li>
					<li>
						<router-link to='/library'>Library</router-link>
					</li>
					<li>
						<router-link v-if="$store.getters.userId != '0'" :to="{path:'/profile/' + $store.getters.userId}">Profile</router-link>
					</li>
				</ul>
			</span>
			<button v-on:click="showSearch" class="search icon">Search</button>
			<form @submit.prevent="search" id="search-nav-widget">
				<button  class="cancel icon" v-on:click.prevent="hideSearch">Cancel</button>
				<input id="search-bar" name="search" placeholder="Search">
				<button class="search icon" type="submit">Search</button>
			</form>
		</nav>
		<router-view :key="$route.fullPath" />
	</div>
</template>

<script>
	export default 
	{
		data() 
		{
			return {
				email: "",
				password: ""
			}
		},
		created ()
		{
			window.addEventListener('keydown', (e) => {
				if (e.key == 'Enter' && document.activeElement === document.getElementById('search-bar'))
				{
					this.search();
				}
			});
		},
		computed:
		{
			showNotification: function()
			{
				return false;
			}   
		},
		methods:
		{
			toggleMenu: function()
			{
				var mobileMenu = document.getElementById("mobile-menu");

				if(mobileMenu.className == "open")
				{
					mobileMenu.className = "closed";
				}
				else
				{
					mobileMenu.className = "open";
				}
			},
			showLogin: function()
			{
				var login = document.getElementById("login-widget");
				login.className = "visible";
			},
			hideLogin: function()
			{
				var login = document.getElementById("login-widget");
				login.className = "";
			},
			showSearch: function()
			{
				document.getElementById("search-nav-widget").className = "visible";
				document.getElementById("search-bar").focus();
			},
			hideSearch: function()
			{
				document.getElementById("search-bar").value = "";
				document.getElementById("search-nav-widget").className = "";
			},
			togglePassword: function()
			{
				var input = document.getElementById("login-password");
				if (input.type === "password") 
				{
					input.type = "text";
				} 
				else 
				{
					input.type = "password";
				}
			},
			search: function()
			{
				try
				{
					window.navigator.vibrate(30);
				}
				catch(e)
				{
					//pass
				}

				let searchQuery = encodeURIComponent(document.getElementById("search-bar").value).replace(/%20/g,'+');

				if(searchQuery.replace(/[+]/g, '') != "")
				{
					this.$router.push('/search/' + searchQuery);
				}
			},
			async onSubmit()
			{
				try
				{
					window.navigator.vibrate(30);
				}
				catch(e)
				{
					//pass
				}

				let vue = this;
				const server = new XMLHttpRequest();
				var url = 'https://api.bookplate.co/login';
				var data = {
					"email": this.email,
					"password":this.password
				};
				server.open('POST', url, true);
				server.withCredentials = true;
				server.setRequestHeader('Content-type', 'application/json');
				server.getResponseHeader('Set-Cookie');

				server.onreadystatechange = function()
				{
					if(server.readyState == 4 && server.status == 200) 
					{
						vue.$store.dispatch('saveUserLogged', server.response);
						vue.hideLogin();
						vue.$router.go(0);
					}
					else if(server.readyState == 4 && server.status == 401)
					{
						//document.getElementById("login-password").style.background = "#c08989";
						document.getElementById("login-password").setCustomValidity("The email or password is incorrect");
						document.getElementById("login-submit-btn").click();

					}
					else if(server.readyState == 4)
					{
						vue.$alert("Something went wrong. Please try again in a moment, or contact support@bookplate.co.", "Error: " + server.status);
					}
				}
				server.send(JSON.stringify(data));
			}
		},
		watch:
		{
			'$route': function() 
			{
				var mobileMenu = document.getElementById("mobile-menu");

				if(mobileMenu.className == "open")
				{
					mobileMenu.querySelector(':not([disabled])').focus();
					mobileMenu.className = "closed";
				}
			}
		}
	}
</script>